<div mat-dialog-content class="center">
  <div class="mx2 mb3" [class.mt3]="!data.text" [class.mt2]="data.text">
    <mat-spinner class="mx-auto"></mat-spinner>
  </div>

  <div *ngIf="data.text" class="app-spinner-dialog-text bold overflow-hidden">
    {{ data.text }}
  </div>
</div>
